import React, { useEffect, useState } from "react";
import { connect } from "react-redux";
import { token, user, userAgencyObject } from "../../../modules/auth";
import {
  fetchSnapshotReport,
  snapshotReportUnload,
} from "../../../redux/actions";
import Loading from "../../Loading";
import { ButtonTertiary } from "../../Button";
import AgencySnapshotReportTableDash from "./AgencySnapshotReportTableDash";
import { Link } from "react-router-dom";
import { FRONTEND } from "../../../Router/corporate_routes";
import { ToggleReportType } from "../../reports/ToggleReportType";
import { ToggleReportDateFilter } from "../../reports/ToggleReportDateFilter";

function AgencySnapshotDashReport({
  isFetchingSnapshotReport,
  snapshotReport,
  fetchSnapshotReport,
  token,
  snapshotReportUnload,
  agencies,
}) {
  const EVENT_DATE_FILTER = "event_date_from";
  const CREATED_AT_FILTER = "created_at";
  const FINANCIAL_YEAR = "financial";
  const CALENDAR_YEAR = "calendarYear";
  const [dateFilter, setDateFilter] = useState(EVENT_DATE_FILTER);
  const [reportType, setReportType] = useState(CALENDAR_YEAR);

  useEffect(() => {
    return () => {
      snapshotReportUnload();
    };
  }, []);

  useEffect(() => {
    if (agencies && agencies.length > 0) {
      const agencyIds = agencies.map(a => a.id).join(",");
      let queryParams = {
        dateColumn: dateFilter,
        agency: agencyIds,
      };
      if (reportType === "financial") {
        queryParams.reportType = reportType;
      }
      fetchSnapshotReport(token, queryParams);
    }
  }, [dateFilter, reportType, agencies]);

  return (
    <div key={`snapshotReport-${agencies.length}`}>
      <div className={"mb-4"}>
        <div className="flex flex-col md:flex-row items-start justify-between mb-4">
          <h2 className="text-2xl font-bold">Agency Snapshot</h2>

          <div className="flex">
            {(agencies.length === 1 || agencies.length === 1) && (
              <div className="inline-block mr-2">
                <ToggleReportType
                  reportType={reportType}
                  financialYearOnClick={() => {
                    setReportType(FINANCIAL_YEAR);
                  }}
                  calendarYearOnClick={() => {
                    setReportType(CALENDAR_YEAR);
                  }}
                />
              </div>
            )}
            <div className="inline-block">
              <ToggleReportDateFilter
                dateFilter={dateFilter}
                createdAtOnClick={() => {
                  setDateFilter(CREATED_AT_FILTER);
                }}
                eventDateOnClick={() => {
                  setDateFilter(EVENT_DATE_FILTER);
                }}
                EVENT_DATE_FILTER={EVENT_DATE_FILTER}
                CREATED_AT_FILTER={CREATED_AT_FILTER}
              />
            </div>
          </div>
        </div>
      </div>

      {isFetchingSnapshotReport ? (
        <div className="relative" style={{ height: 500 }}>
          <div
            className="absolute pin"
            style={{
              top: "50%",
              left: "50%",
              transform: "translate(-50%, -50%)",
            }}
          >
            <Loading />
          </div>
        </div>
      ) : snapshotReport && snapshotReport.length > 0 ? (
        <AgencySnapshotReportTableDash
          data={snapshotReport}
          dateFilterColumn={dateFilter}
        />
      ) : null}

      {!isFetchingSnapshotReport && (
        <div className="flex justify-start mt-4">
          <ButtonTertiary
            style={{ width: "inherit" }}
            classes="text-md font-bold mr-2"
          >
            <Link to={FRONTEND.REPORTS.INDEX} className={"text-white"}>
              View Reports
            </Link>
          </ButtonTertiary>
        </div>
      )}
    </div>
  );
}

const mapStateToProps = state => {
  return {
    selectedAgencies: state.selectedAgencies,
    ...state.snapshotReport,
    user: user(state),
    agency: userAgencyObject(state),
    token: token(state),
  };
};

const mapDispatchToProps = {
  fetchSnapshotReport,
  snapshotReportUnload,
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(AgencySnapshotDashReport);
